<template>
  <router-link v-if="destination" :to="destination" class="gs-studio-breadcrumb" aria-label="Back to Funnel Studio">
    <svg viewBox="0 0 20 20" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="m12 4-6 6 6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>
    <span>Back to Funnel Studio</span>
  </router-link>
</template>
<script>
import { funnelStudioReturn } from '@/router/utils/funnel-studio-context';
export default { name:'FunnelStudioBreadcrumb', computed:{ destination() { return funnelStudioReturn(this.$route); } } };
</script>
<style scoped>
.gs-studio-breadcrumb { display:inline-flex; align-items:center; flex-shrink:0; gap:7px; min-height:36px; margin-right:18px; padding:6px 10px; border:1px solid #DCE3EF; border-radius:8px; color:#3E5684; background:#F5F8FF; font-size:12px; font-weight:600; line-height:1.35; text-decoration:none; }
.gs-studio-breadcrumb:hover { color:#264C95; background:#EBF1FE; border-color:#ACC0E6; }
.gs-studio-breadcrumb:focus-visible { outline:3px solid #7199EF; outline-offset:3px; }
@media(max-width:600px) { .gs-studio-breadcrumb { max-width:125px; margin-right:10px; padding:6px 8px; } }
</style>
